import {
  EdmGenreType,
  EdmMedicalPerson,
  EdmVisitTimeDuration,
} from "lib/graphql/megaSchema";
import { isMidwife, isNurse } from "lib/tools/auth";

export const getStaffGenreLabel = (
  staff: Pick<EdmMedicalPerson, "genre" | "npwz" | "gender">,
) => {
  if (isNurse(staff)) {
    return staff.gender === "FEMALE" ? "Pielęgniarka" : "Pielęgniarz";
  }

  if (isMidwife(staff)) {
    return staff.gender === "FEMALE" ? "Położna" : "Położny";
  }

  return staff.gender === "FEMALE" ? "Lekarka rodzinna" : "Lekarz rodzinny";
};

export const transformedUserGenre = (
  staff: Pick<EdmMedicalPerson, "genre" | "npwz" | "gender">,
) => {
  if (isNurse(staff)) {
    return "NURSE";
  }

  if (isMidwife(staff)) {
    return "MIDWIFE";
  }

  return "DOCTOR";
};

type FieldConfig = {
  name: keyof EdmVisitTimeDuration;
  label: string;
};

export const genreToFieldsMap: Record<
  Extract<EdmGenreType, "DOCTOR" | "NURSE" | "MIDWIFE">,
  FieldConfig[]
> = {
  DOCTOR: [
    { name: "IN_PERSON", label: "Osobista" },
    { name: "TELEMEDICAL", label: "Telemedyczna" },
    { name: "DOCTOR_TELEMEDICAL_INFECTION", label: "Telemedyczna infekcyjna" },
    { name: "RADIOLOGY_APPOINTMENT", label: "USG" },
    { name: "EXPRESS_APPOINTMENT", label: "Ekspresowa" },
    { name: "DOCTOR_HOUSE_CALL", label: "Domowa" },
    { name: "HEALTHY_CHILDREN_CHECKUP", label: "Dzieci bilans" },
    {
      name: "HEALTHY_CHILDREN_CHECKUP_AND_VACCINE",
      label: "Dzieci bilans + szczepienie",
    },
    { name: "HEALTHY_CHILDREN_PATRONAGE", label: "Dzieci patronaż" },
    { name: "HEALTHY_CHILDREN_VACCINE", label: "Dzieci szczepienia" },
  ],
  NURSE: [
    { name: "PROCEDURE", label: "Zabiegowe" },
    { name: "COLLECTION", label: "Pobranie" },
    { name: "NURSE_IN_PERSON_INFECTION", label: "Infekcyjna pielęgniarska" },
    { name: "NURSE_IN_PERSON", label: "Osobista pielęgniarska" },
    { name: "NURSE_HOUSE_CALL", label: "Domowa" },
    { name: "NURSE_HEALTHY_CHILDREN", label: "Dzieci zdrowe" },
  ],
  MIDWIFE: [
    { name: "MIDWIFE_HOUSE_CALL", label: "Patronaż" },
    { name: "MIDWIFE_IN_PERSON", label: "Edukacja" },
  ],
};

export const defaultVisitsTimeDuration: EdmVisitTimeDuration = {
  COLLECTION: null,
  DOCTOR_HOUSE_CALL: null,
  DOCTOR_TELEMEDICAL_INFECTION: null,
  EXPRESS_APPOINTMENT: null,
  IN_PERSON: null,
  MIDWIFE_HOUSE_CALL: null,
  MIDWIFE_IN_PERSON: null,
  NURSE_HOUSE_CALL: null,
  NURSE_IN_PERSON_INFECTION: null,
  PRESCRIPTION_APPOINTMENT: null,
  PROCEDURE: null,
  RADIOLOGY_APPOINTMENT: null,
  SPECIALIST: null,
  TELEMEDICAL: null,
};
